import { useState, useEffect } from "react";

/**
 * Custom hook for scroll to top button visibility
 * @param {number} threshold - Scroll threshold in pixels (default: 400)
 * @returns {Object} Scroll state and handler
 */
export const useScrollToTop = (threshold = 400) => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setShowScrollTop(window.scrollY > threshold);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [threshold]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return {
        showScrollTop,
        scrollToTop
    };
};

